<template>
    <div>
        <div class="first" v-if="step == '1'">
            <!-- 评定分离 -->
            <div v-if="data.pdfl == '1'" class="template-box">
                <el-button type="primary" @click="choose('pdfl_pbbg_sg')">评定分离施工模板</el-button>
                <el-button type="primary" @click="choose('pdfl_pbbg_kc')">评定分离勘察模板</el-button>
                <el-button type="primary" @click="choose('pdfl_pbbg_jl')">评定分离监理模板</el-button>
                <el-button type="primary" @click="choose('pdfl_pbbg_sj')">评定分离设计模板</el-button>
            </div>
            <div v-else>
                <!-- 邯郸住建模板 -->
                <div v-if="data.ext_deptcode == '4' && data.hdzj == '1'"> class="template-box"
                    <el-button type="primary" @click="choose('pbbg_sg_hdzj')">邯郸住建项目施工模板</el-button>
                    <el-button type="primary" @click="choose('pbbg_zgys_hdzj')">邯郸住建项目资格预审模板</el-button>
                    <el-button type="primary" @click="choose('pbbg_jl_hdzj')">邯郸住建项目监理模板</el-button>
                    <el-button type="primary" @click="choose('pbbg_epc_hdzj')">邯郸住建项目EPC模板</el-button>
                </div>
                <!-- 普通住建模板 -->
                <div v-if="data.ext_deptcode == '4' && data.hdzj != '1'">
                    <div class="template-box">
                        <el-button type="primary" @click="choose('pbbg_sg')">住建项目施工模板</el-button>
                        <el-button type="primary" @click="choose('pbbg_kc')">住建项目勘察模板</el-button>
                        <el-button type="primary" @click="choose('pbbg_sj')">住建项目设计模板</el-button>
                    </div>
                    <div class="template-box" style="margin-top:20px;">
                        <el-button type="primary" @click="choose('pbbg_jl')">住建项目监理模板</el-button>
                        <el-button type="primary" @click="choose('pbbg_epc')">住建项目EPC模板</el-button>
                        <el-button type="primary" @click="choose('pbbg_zgys')">住建项目资格预审模板</el-button>
                    </div>
                </div>
                <!-- 交通按类报名 -->
                <div v-if="data.ext_deptcode == '0' && data.albm == '1'" class="template-box">
                    <el-button type="primary" @click="choose('pbbg_jt_albm_fw')">交通按类-服务模板</el-button>
                    <el-button type="primary" @click="choose('pbbg_jt_albm_sb')">交通按类-设备模板</el-button>
                    <el-button type="primary" @click="choose('pbbg_jt_albm_sg')">交通按类-施工模板</el-button>
                </div>
            </div>
        </div>
        <div class="second template-box" v-if="step == '2'">
            <el-button type="primary" @click="downloadTemplate">下载word版</el-button>
            <el-button type="primary" @click="editTemplate">在线编辑word</el-button>
        </div>
        <a style="display:none;" :href="templateFileUrl" class="downloadTag" download="评标报告.docx"></a>
    </div>
</template>
<script>
    export default{
        props:{
            data:{
                type:Object,
                default:{}
            }
        },
        data(){
            return{
                step:'1',
                templateType:"",
                templateFileUrl:"",
                templateFileKey:"",
                templateIframeUrl:"",
            }
        },
        watch:{
            
        },
        methods:{
            //清空生成的模板
            clearTemplate(){
                this.templateFileUrl = "";
                this.templateFileKey = "";
                this.templateIframeUrl = "";
                this.step = '1';
                this.templateType = "";
            },
            //选择模板
            choose(type){
                this.templateType = type;
                this.generate(type);
            },
            //生成报告
            generate(type){
                var that = this;
                that.$get(`${this.getGetters('bidUrl')}/revision/kaibiao/pbbgmb/getPbbgUrl.json`,{
                    bdcode:that.data.bdcode,
                    template:type,
                }, (data, res) => {
                    that.templateFileUrl = "/standalonfile/download/path.do?destpath=" + data.path;
                    that.templateFileKey = data.key;
                    that.templateIframeUrl = data.iframeUrl;
                    that.step = '2';
                });
            },
            //下载报告
            downloadTemplate(){
                $(".downloadTag")[0].click();
            },
            //编辑报告
            editTemplate(){
                var that = this;
                
                var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
                var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
                var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
                if(isIE || isIE11) {
                    this.$alert('IE及浏览器兼容模式不支持在线编辑，请使用谷歌浏览器或360浏览器极速模式', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            
                        }
                    });
                    return 
                }
		        
                this.goto({
                    path: './onlineEdit',
                    query: {
                        zbprocode:that.getQuery('zbprocode'),
                        zgys:that.getQuery('zgys'),
                        templateFileKey : that.templateFileKey,
                        templateIframeUrl : that.templateIframeUrl
                    }
                })
            },
            

        },
        mounted(){
            if(this.data.pdfl != '1'){
                if(this.data.ext3 != '' && this.data.ext3 != null){
                    if(this.data.ext3 == '5' && this.data.isqycg == '1'){
                        this.choose('zfcg_pbbg_zfcgbx');//比选
                    }else if(this.data.ext3 == '5' && this.data.isqycg != '1'){
                        this.choose('zfcg_pbbg_zfcgxj');//邢健
                    }else if(this.data.ext3 != '5'){
                        if(this.data.ext3 == '2'){//政采各个类型模板
                            this.choose('zfcg_pbbg_zfcggk');
                        }else if(this.data.ext3 == '3'){
                            this.choose('zfcg_pbbg_jzxtp');
                        }else if(this.data.ext3 == '4'){
                            this.choose('zfcg_pbbg_zfcggk');
                        }else if(this.data.ext3 == '6'){
                            this.choose('zfcg_pbbg_jzxcs');
                        }else if(this.data.ext3 == '7'){
                            this.choose('zfcg_pbbg_zfcgdyly');
                        }
                    }
                }else if(this.data.ext_deptcode != '4' && this.data.albm != '1'){
                    this.choose('pbbg_ty');
                }
            }
        }
    }
</script>
<style scoped>
    .template-box{ display: flex;justify-content: center; }
    .el-button--primary{ width: 200px; }
    
</style>
